import ShelfController from '../../core/shelf.controller';

/**
 * Controller for the dedicated auditor product-approval screen.
 * Lists products pending approval newest-first and lets an admin approve/reject
 * them (individually or in bulk) before they enter the catalog.
 */
class ProductApprovalController extends ShelfController {
    state = {
        items: [],
        loading: true,
        pagination: { page: 1, limit: 24, total: 0, pages: 1 },
        selectedIds: [],
        busy: false,
    };

    async initialize() {
        if (!this.isAuthenticated) {
            this.navigateLogin();
            return;
        }
        await this.loadQueue(1);
    }

    async loadQueue(page = 1) {
        this.setState({ loading: true });
        try {
            const res = await this.data.fetchAuditAdminReviewQueue({
                page,
                limit: this.state.pagination.limit || 24,
                sort: 'newest', // latest first
            });
            if (res?.success) {
                this.setState({
                    items: res.data?.items || [],
                    pagination: res.data?.pagination || { page, limit: 24, total: 0, pages: 1 },
                    selectedIds: [],
                    loading: false,
                });
            } else {
                this.props.onMessage?.('error', res?.message || 'Error al cargar productos por aprobar');
                this.setState({ loading: false });
            }
        } catch (e) {
            this.props.onMessage?.('error', e?.response?.data?.message || e?.message || 'Error al cargar productos por aprobar');
            this.setState({ loading: false });
        }
    }

    toggleSelect = (id, checked) => {
        if (!id) return;
        this.setState((prev) => ({
            selectedIds: checked ? [...prev.selectedIds, id] : prev.selectedIds.filter((x) => x !== id),
        }));
    };

    toggleSelectAll = (checked) => {
        this.setState((prev) => ({
            selectedIds: checked ? prev.items.map((i) => i.product?._id).filter(Boolean) : [],
        }));
    };

    async _bulkUpdate(ids, updates, successMsg) {
        if (!ids?.length) return;
        this.setState({ busy: true });
        try {
            const res = await this.data.bulkUpdateAuditAdminProducts({ ids, updates });
            if (res?.success) {
                this.props.onMessage?.('success', `${successMsg} (${res.data?.modified ?? ids.length})`);
                await this.loadQueue(this.state.pagination.page || 1);
            } else {
                this.props.onMessage?.('error', res?.message || 'No se pudo completar la operación');
            }
        } catch (e) {
            this.props.onMessage?.('error', e?.response?.data?.message || e?.message || 'Error en la operación');
        } finally {
            this.setState({ busy: false });
        }
    }

    // Approving puts the product in the catalog; rejecting archives it (active:false).
    approve = (product) =>
        this._bulkUpdate([product?._id], { status: 'complete', missingData: false, reviewStatus: 'approved' }, 'Producto aprobado');

    reject = (product) => this._bulkUpdate([product?._id], { reviewStatus: 'rejected', active: false }, 'Producto rechazado');

    approveSelected = () =>
        this._bulkUpdate(this.state.selectedIds, { status: 'complete', missingData: false, reviewStatus: 'approved' }, 'Productos aprobados');

    rejectSelected = () => this._bulkUpdate(this.state.selectedIds, { reviewStatus: 'rejected', active: false }, 'Productos rechazados');

    // Scan thumbnails open the console's records tab.
    openRecords = () => this.props.navigate?.('/dashboard/trade/audit-console?tab=records');

    // Full editing lives in the audit console; jump there pre-filtered by code.
    openInConsole = (product) =>
        this.props.navigate?.(`/dashboard/trade/audit-console?tab=products&search=${encodeURIComponent(product?.code || '')}`);
}

export default ProductApprovalController;
